import { render, staticRenderFns } from "./CustomerPopup.vue?vue&type=template&id=aea203be&scoped=true&"
import script from "./CustomerPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPopup.vue?vue&type=style&index=0&id=aea203be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea203be",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/CustomerPopup.vue
// module id = null
// module chunks = 